import { generateUtilityClass, generateUtilityClasses } from '../../styles/classes';
export var formActionsComponentName = 'QuantumFormActions';
export function getFormActionsUtilityClass(slot) {
    return generateUtilityClass(formActionsComponentName, slot);
}
export var formActionsClasses = generateUtilityClasses(formActionsComponentName, ['root', 'actions']);
